import { atom } from "jotai";

const bopisInventoryAtom = atom({
  bopisQuantity: null,
  skuQuantities: null,
  inventory: null,
});

export default bopisInventoryAtom;
